// import React, { useState, useEffect } from "react";
// import { Row, Col, Form } from "react-bootstrap";
// import { deleteClass } from "../services/APIClient";
// import { useNavigate } from "react-router";
// import "./EditClassDetails.css";

// function EditClassDetailsSpecial(props) {
//   const [show, setShow] = useState(false);
//   const navigate = useNavigate();

//   const deleteClassHandler = () => {
//     deleteClass(props.classDetails.id);
//     navigate("/classadmindashboard");
//   };

//   const { classDetails, name, gradeLevel, setIsNameUpdated } = props;
//   const dateCreated = classDetails.date_created;
//   const dateUpdated = classDetails.date_updated;

//   const yearCreated = dateCreated ? dateCreated.substring(0, 4) : "";
//   const yearUpdated = dateUpdated ? dateUpdated.substring(0, 4) : "";

//   // Initialize state with current values
//   const [updatedName, setUpdatedName] = useState(name || "");
//   const [updatedGradeLevel, setUpdatedGradeLevel] = useState(gradeLevel || "");

//   // Update state if props change
//   useEffect(() => {
//     setUpdatedName(name || "");
//   }, [name]);

//   useEffect(() => {
//     setUpdatedGradeLevel(gradeLevel || "");
//   }, [gradeLevel]);

//   // Handle class name changes
//   const nameUpdate = (e) => {
//     const inputName = e.target.value.trim();
//     setUpdatedName(inputName);
//   };

//   // Handle onBlur to reset to original name if input is empty
//   const handleNameBlur = () => {
//     if (updatedName.trim() === "") {
//       setUpdatedName(name);
//       setIsNameUpdated(false);
//     }
//   };

//   // Handle grade level changes
//   const gradeUpdate = (e) => {
//     const inputGrade = e.target.value.trim();
//     setUpdatedGradeLevel(inputGrade);
//   };

//   // Handle onBlur to reset to original grade if input is empty
//   const handleGradeBlur = () => {
//     if (updatedGradeLevel.trim() === "") {
//       setUpdatedGradeLevel(gradeLevel);
//     }
//   };

//   // Effect to send name updates and track changes
//   useEffect(() => {
//     if (updatedName !== name && updatedName.trim() !== "") {
//       console.log("Sending Updated Name:", updatedName);
//       props.sendUpdateClassName(updatedName);
//       setIsNameUpdated(true);
//     } else if (updatedName === name) {
//       setIsNameUpdated(false);
//     }
//   }, [updatedName, name, props, setIsNameUpdated]);

//   // Effect to send grade updates
//   useEffect(() => {
//     if (updatedGradeLevel !== gradeLevel && updatedGradeLevel.trim() !== "") {
//       console.log("Sending Updated Grade:", updatedGradeLevel);
//       props.sendUpdateGrade(updatedGradeLevel);
//     }
//   }, [updatedGradeLevel, gradeLevel, props]);

//   return (
//     <>
//       <Form className="form">
//         {/* Instructional Message Box */}

//         {/* Class Name Field */}
//         <Form.Group as={Row} className="mb-3" controlId="class-name">
//           <Form.Label className="label" column sm="4">
//             <p>Class Name</p>
//           </Form.Label>
//           <Col sm="8">
//             <Form.Control
//               placeholder={"Insert new class name...."}
//               // value={updatedName}
//               size="md"
//               type="text"
//               onChange={nameUpdate}
//               onBlur={handleNameBlur}
//             />
//           </Col>
//         </Form.Group>

//         {/* Grade Level Field */}
//         <Form.Group as={Row} className="mb-3" controlId="grade-level">
//           <Form.Label className="label" column sm="4">
//             <p>Grade Level</p>
//           </Form.Label>
//           <Col sm="8">
//             <Form.Control
//               placeholder={gradeLevel}
//               value={updatedGradeLevel}
//               size="md"
//               type="text"
//               onChange={gradeUpdate}
//               onBlur={handleGradeBlur}
//               disabled
//             />
//           </Col>
//         </Form.Group>

//         {/* School Year Field */}
//         <Form.Group as={Row} className="mb-3" controlId="year">
//           <Form.Label className="label" column sm="4">
//             <p>School Year</p>
//           </Form.Label>
//           <Col sm="8">
//             <Form.Control
//               placeholder={yearCreated}
//               size="md"
//               type="text"
//               disabled
//             />
//           </Col>
//         </Form.Group>
//       </Form>
//     </>
//   );
// }

// export default EditClassDetailsSpecial;

import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { deleteClass } from "../services/APIClient";
import { useNavigate } from "react-router";
import "./EditClassDetails.css";

function EditClassDetailsSpecial(props) {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const deleteClassHandler = () => {
    deleteClass(props.classDetails.id);
    navigate("/classadmindashboard");
  };

  const { classDetails, name, gradeLevel, setIsNameUpdated } = props;
  const dateCreated = classDetails.date_created;
  const dateUpdated = classDetails.date_updated;

  const yearCreated = dateCreated ? dateCreated.substring(0, 4) : "";
  const yearUpdated = dateUpdated ? dateUpdated.substring(0, 4) : "";

  // Initialize state with current values
  const [updatedName, setUpdatedName] = useState(name || "");
  const [updatedGradeLevel, setUpdatedGradeLevel] = useState(gradeLevel || "");

  // Update state if props change
  useEffect(() => {
    setUpdatedName(name || "");
  }, [name]);

  useEffect(() => {
    setUpdatedGradeLevel(gradeLevel || "");
  }, [gradeLevel]);

  // Handle class name changes
  const nameUpdate = (e) => {
    const inputName = e.target.value.trim();
    setUpdatedName(inputName);
  };

  // Handle onBlur to reset to original name if input is empty
  const handleNameBlur = () => {
    if (updatedName.trim() === "") {
      setUpdatedName(name);
      setIsNameUpdated(false);
    }
  };

  // Handle grade level changes
  const gradeUpdate = (e) => {
    const inputGrade = e.target.value.trim();
    setUpdatedGradeLevel(inputGrade);
  };

  // Handle onBlur to reset to original grade if input is empty
  const handleGradeBlur = () => {
    if (updatedGradeLevel.trim() === "") {
      setUpdatedGradeLevel(gradeLevel);
    }
  };

  // Effect to send name updates and track changes
  useEffect(() => {
    if (updatedName !== name && updatedName.trim() !== "") {
      console.log("Sending Updated Name:", updatedName);
      props.sendUpdateClassName(updatedName);
      setIsNameUpdated(true);
    } else if (updatedName === name) {
      setIsNameUpdated(false);
    }
  }, [updatedName, name, props, setIsNameUpdated]);

  // Effect to send grade updates
  useEffect(() => {
    if (updatedGradeLevel !== gradeLevel && updatedGradeLevel.trim() !== "") {
      console.log("Sending Updated Grade:", updatedGradeLevel);
      props.sendUpdateGrade(updatedGradeLevel);
    }
  }, [updatedGradeLevel, gradeLevel, props]);

  return (
    <>
      <Form className="form">
        {/* Instructional Message Box */}

        {/* Class Name Field */}
        <Form.Group as={Row} className="mb-3" controlId="class-name">
          <Form.Label className="label" column sm="4">
            <p>Class Name</p>
          </Form.Label>
          <Col sm="8">
            <Form.Control
              placeholder={"Insert new class name...."}
              // value={updatedName}
              size="md"
              type="text"
              onChange={nameUpdate}
              onBlur={handleNameBlur}
            />
          </Col>
        </Form.Group>

        {/* Grade Level Field */}
        <Form.Group as={Row} className="mb-3" controlId="grade-level">
          <Form.Label className="label" column sm="4">
            <p>Grade Level</p>
          </Form.Label>
          <Col sm="8">
            <Form.Control
              placeholder={gradeLevel}
              value={updatedGradeLevel}
              size="md"
              type="text"
              onChange={gradeUpdate}
              onBlur={handleGradeBlur}
              disabled
            />
          </Col>
        </Form.Group>

        {/* School Year Field */}
        <Form.Group as={Row} className="mb-3" controlId="year">
          <Form.Label className="label" column sm="4">
            <p>School Year</p>
          </Form.Label>
          <Col sm="8">
            <Form.Control
              placeholder={yearCreated}
              size="md"
              type="text"
              disabled
            />
          </Col>
        </Form.Group>
      </Form>
    </>
  );
}

export default EditClassDetailsSpecial;